import Phaser from 'phaser';
import { phaserInternalSize } from './render-budget';
import { BootScene } from './scenes/BootScene';
import { HudScene } from './scenes/HudScene';
import { UiScene } from './scenes/UiScene';
import { WorldScene } from './scenes/WorldScene';
import { scaleModeForDevice } from './viewbox';

export function createGameConfig(parent: HTMLElement | string): Phaser.Types.Core.GameConfig {
  const internal = phaserInternalSize();

  return {
    type: Phaser.WEBGL,
    parent,
    width: internal.width,
    height: internal.height,
    backgroundColor: '#9fd0e8',
    render: {
      antialias: false,
      roundPixels: true,
      powerPreference: 'high-performance',
      batchSize: 8192,
    },
    fps: {
      target: 60,
      forceSetTimeOut: false,
      smoothStep: false,
    },
    input: {
      activePointers: 1,
      windowEvents: false,
      smoothFactor: 0,
    },
    scale: {
      mode: scaleModeForDevice(),
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: internal.width,
      height: internal.height,
    },
    scene: [BootScene, WorldScene, HudScene, UiScene],
  };
}
